import cookie from "js-cookie";

const BEARER_TOKEN_COOKIE_NAME = "bearer_token";

export const setBearerTokenCookie = (token: string) => {
    token = token?.trim();

    if (!token) {
        console.warn("Attempted to set invalid bearer token");
        return;
    }

    cookie.set(BEARER_TOKEN_COOKIE_NAME, token, {
        sameSite: "lax",
        secure: window.location.protocol === "https:",
        path: "/",
    });
};

export const getBearerTokenCookie = (): string | undefined => {
    return cookie.get(BEARER_TOKEN_COOKIE_NAME);
};
